'use strict';

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultWarningMessages = require('./defaultWarningMessages');

var _defaultWarningMessages2 = _interopRequireDefault(_defaultWarningMessages);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var warningMessage = function warningMessage() {
  var defaultWarningMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultWarningMessages2["default"];

  var date = function date(message) {
    return message || defaultWarningMessages.date;
  };

  var datetime = function datetime(message) {
    return message || defaultWarningMessages.datetime;
  };

  var email = function email(message) {
    return message || defaultWarningMessages.email;
  };

  var exactly = function exactly(target, message) {
    var exactlyWarningMessage = defaultWarningMessages.exactly;

    if (message !== undefined) {
      return message(target);
    }

    exactlyWarningMessage = exactlyWarningMessage.replace(RegExp('__VAR1__'), target);
    return exactlyWarningMessage;
  };

  var _float = function _float2(message) {
    return message || defaultWarningMessages["float"];
  };

  var integer = function integer(message) {
    return message || defaultWarningMessages.integer;
  };

  var maxChar = function maxChar(max, message) {
    var maxCharWarningMessage = defaultWarningMessages.maxChar;

    if (message !== undefined) {
      return message(max);
    }

    maxCharWarningMessage = maxCharWarningMessage.replace(RegExp('__VAR1__'), max);
    return maxCharWarningMessage;
  };

  var minChar = function minChar(min, message) {
    var minCharWarningMessage = defaultWarningMessages.minChar;

    if (message !== undefined) {
      return message(min);
    }

    minCharWarningMessage = minCharWarningMessage.replace(RegExp('__VAR1__'), min);
    return minCharWarningMessage;
  };

  var minMaxChar = function minMaxChar(min, max, message) {
    var minMaxCharWarningMessage = defaultWarningMessages.minMaxChar;

    if (message !== undefined) {
      return message(min, max);
    }

    minMaxCharWarningMessage = minMaxCharWarningMessage.replace(RegExp('__VAR1__'), min);
    minMaxCharWarningMessage = minMaxCharWarningMessage.replace(RegExp('__VAR2__'), max);
    return minMaxCharWarningMessage;
  };

  var not = function not(value, message) {
    var notWarningMessage = defaultWarningMessages.not;

    if (message !== undefined) {
      return message(value);
    }

    notWarningMessage = notWarningMessage.replace(RegExp('__VAR1__'), value);
    return notWarningMessage;
  };

  var number = function number(message) {
    return message || defaultWarningMessages.number;
  };

  var phonenumber = function phonenumber(message) {
    return message || defaultWarningMessages.phonenumber;
  };

  var requiredField = function requiredField(message) {
    return message || defaultWarningMessages.requiredField;
  };

  var time = function time(message) {
    return message || defaultWarningMessages.time;
  };

  var url = function url(message) {
    return message || defaultWarningMessages.url;
  };

  var validation = function validation(message) {
    return message || defaultWarningMessages.validation;
  };

  return {
    date: date,
    datetime: datetime,
    email: email,
    exactly: exactly,
    "float": _float,
    integer: integer,
    maxChar: maxChar,
    minChar: minChar,
    minMaxChar: minMaxChar,
    not: not,
    number: number,
    phonenumber: phonenumber,
    requiredField: requiredField,
    time: time,
    url: url,
    validation: validation
  };
};

exports["default"] = warningMessage;
module.exports = exports['default'];